function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module html-embed/updatehtmlembedcommand
 */
import { Command } from 'ckeditor5/src/core';
/**
 * The update HTML embed value command.
 *
 * The command is registered by {@link module:html-embed/htmlembedediting~HtmlEmbedEditing} as `'updateHtmlEmbed'`.
 *
 * To update the value of the HTML embed element at the current selection, execute the command:
 *
 *		editor.execute( 'updateHtmlEmbed', '<b>HTML.</b>' );
 *
 * @extends module:core/command~Command
 */

var UpdateHtmlEmbedCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(UpdateHtmlEmbedCommand, _Command);

  function UpdateHtmlEmbedCommand() {
    _classCallCheck(this, UpdateHtmlEmbedCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(UpdateHtmlEmbedCommand).apply(this, arguments));
  }

  _createClass(UpdateHtmlEmbedCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var model = this.editor.model;
      var selection = model.document.selection;
      var rawHtmlElement = getSelectedRawHtmlModelWidget(selection);
      this.isEnabled = !!rawHtmlElement;
    }
    /**
     * Executes the command, which updates the `value` attribute of the embedded HTML element:
     *
     * @fires execute
     * @param {String} value HTML as a string.
     */

  }, {
    key: "execute",
    value: function execute(value) {
      var model = this.editor.model;
      var selection = model.document.selection;
      var selectedRawHtmlElement = getSelectedRawHtmlModelWidget(selection);
      model.change(function (writer) {
        writer.setAttribute('value', value, selectedRawHtmlElement);
      });
    }
  }]);

  return UpdateHtmlEmbedCommand;
}(Command); // Returns the selected HTML embed element in the model, if any.
//
// @param {module:engine/model/selection~Selection} selection
// @returns {module:engine/model/element~Element|null}


export { UpdateHtmlEmbedCommand as default };

function getSelectedRawHtmlModelWidget(selection) {
  var selectedElement = selection.getSelectedElement();

  if (selectedElement && selectedElement.is('element', 'rawHtml')) {
    return selectedElement;
  }

  return null;
}